// Subscription payment status polling for /payment/status — display only.
// Activation happens on the backend when the signature-verified Cashfree
// webhook lands; this script merely polls the recorded status. The status
// page consumes its one-time cache token on first render, so a pending
// ("Process") subscription payment is resolved here by polling the local
// proxy endpoint and swapping the panel in place — never reloading.
(function () {
    'use strict';

    if (window.location.pathname !== '/payment/status') return;

    var panel = document.getElementById('subscription-status-poll');
    if (!panel) return;

    var transactionId = panel.dataset.transaction;
    var successUrl = panel.dataset.successUrl || '/myaccount?tab=payments&pay=subscription';
    if (!transactionId) return;

    var POLL_INTERVAL_MS = 4000;
    var MAX_ATTEMPTS = 30;
    var attempts = 0;

    var RESULT_ICONS = {
        success: 'payment-result__icon--success ri-checkbox-circle-fill',
        failed: 'payment-result__icon--failed ri-close-circle-fill',
        pending: 'payment-result__icon--pending ri-time-line'
    };

    function renderResult(state, title, message, ctaLabel, ctaHref) {
        var iconParts = (RESULT_ICONS[state] || RESULT_ICONS.pending).split(' ');
        panel.innerHTML = ''
            + '<div class="payment-result__icon ' + iconParts[0] + '"><i class="' + iconParts[1] + '"></i></div>'
            + '<h3 class="payment-result__title"></h3>'
            + '<p class="payment-result__text"></p>'
            + '<span class="payment-result__ref"></span><br>'
            + '<a class="payment-result__cta"></a>';
        panel.querySelector('h3').textContent = title;
        panel.querySelector('p').textContent = message;
        panel.querySelector('.payment-result__ref').textContent = transactionId;
        var cta = panel.querySelector('a');
        cta.textContent = ctaLabel;
        cta.href = ctaHref;
    }

    function poll() {
        attempts += 1;

        fetch('/api/payment/subscription_status?transaction_id=' + encodeURIComponent(transactionId), {
            method: 'POST',
            credentials: 'same-origin'
        })
        .then(function (resp) {
            return resp.json().then(function (body) {
                return { ok: resp.ok, body: body };
            });
        })
        .then(function (result) {
            var state = (result.ok && result.body && result.body.data)
                ? String(result.body.data.transaction_status || '').toLowerCase()
                : '';

            if (state === 'success') {
                renderResult(
                    'success',
                    'Subscription active!',
                    'Your autopay mandate is set up and your payment is confirmed. Every course is now unlocked.',
                    'Go to Subscription',
                    successUrl
                );
                return;
            }

            if (state === 'failed') {
                renderResult(
                    'failed',
                    'Authorization failed',
                    'The authorization did not complete. No charge was made — you can try again anytime.',
                    'Try Again',
                    '/payment/subscribe'
                );
                return;
            }

            if (attempts >= MAX_ATTEMPTS) {
                renderResult(
                    'pending',
                    'Still confirming',
                    'The bank is taking longer than usual to confirm. Your subscription activates automatically once it settles — check My Account in a few minutes.',
                    'Go to Subscription',
                    successUrl
                );
                return;
            }

            setTimeout(poll, POLL_INTERVAL_MS);
        })
        .catch(function (err) {
            console.error('Subscription status poll failed:', err);
            if (attempts >= MAX_ATTEMPTS) {
                renderResult(
                    'pending',
                    'Still processing',
                    'We could not confirm the payment yet. Check My Account in a few minutes.',
                    'Go to Subscription',
                    successUrl
                );
                return;
            }
            setTimeout(poll, POLL_INTERVAL_MS);
        });
    }

    setTimeout(poll, POLL_INTERVAL_MS);
})();
